import React, { useRef, useState, useEffect} from "react";
import emailjs from '@emailjs/browser';
import Footer from "../../PortfolioContainer/footer/Footer";
import "./ContactMe.css";



export default function ContactMe(props) {
  const [isMessageSent, setIsMessageSent] = useState(false);
  const form = useRef();

  useEffect(() => {
    setIsMessageSent(false);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_1hib56h', 'template_yghqvyc', form.current, 'tNnjTqhQnG6FdPMUU')
      .then(() => {
        setIsMessageSent(true);
      })
      .catch(() => {
        setIsMessageSent(false);
      });
  };

  return (
    
    <div className="contact-me-container">
      <div id="ContactMe"></div>

      <div className="form-container">
        <h1>Contact Me</h1>
        <form ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" />
          <label>Email</label>
          <input type="email" name="user_email" />
          <label>Message</label>
          <textarea name="message" />
          <input type="submit" value={isMessageSent ? "Message Sent" : "Send"} disabled={isMessageSent} className={isMessageSent ? "green-button" : "" } />
        </form>
      </div>
      <Footer />
    </div>
  );
}
